import React, { useState, useContext, useEffect } from "react";
import { Formik, Form, FastField } from "formik";
import * as Yup from "yup";
import CssTextField from "Components/CssTextField";
import CssSelectField from "Components/CssSelectField";
import CssButton from "Components/CssButton";
import FileUpload from "Components/FileUpload";
import TagsInput from "Components/TagsInput";
import { useNavigate, useParams } from "react-router-dom";
import {
  Grid,
  FormControl,
  MenuItem,
  InputLabel,
  Stack,
  Container,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import useRequests from "services/request-hook";
import ModalContainer from "Components/ModalContainer";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import useApi from "services/api-hook";
import { GlobalState } from "../../context/GlobalContext";
import CssCircularProgress from "Components/CssCircularProgress";
import { styled } from '@mui/material/styles';
import AddIcon from "@mui/icons-material/Add";
import AssetsForm from "./AssetsForm";

const CssTabs = styled(Tabs)({
  marginBottom: "10px",
  "& .MuiTabs-indicator": {
    backgroundColor: "#fff",
  }
});

const CssTab = styled(Tab)({
  "&.Mui-selected": {
    color: "#fff",
  },
}); 

const typeOptions = [
  { value: "2D", label: "2D" },
  { value: "3D", label: "3D" },
];

const fontFamilyOptions = [
  { value: "Default", label: "Default" },
  { value: "Georgia", label: "Georgia" },
  { value: "Verdana", label: "Verdana" },
  { value: "Marrieweather", label: "Marrieweather" },
];

const fontSizeOptions = [
  { value: "12", label: "12" },
  { value: "14", label: "14" },
  { value: "16", label: "16" },
  { value: "18", label: "18" },
  { value: "20", label: "20" },
  { value: "22", label: "22" },
  { value: "24", label: "24" },
  { value: "26", label: "26" },
];

const statusOptions = [
  { value: "DRAFT", label: "Draft" },
  { value: "PUBLISHED", label: "Published" },
  { value: "ARCHIVED", label: "Archived" },
];
const SUPPORTED_AUDIO_FORMATS = ["audio/mp3", "audio/ogg", "audio/mpeg"];
const SUPPORTED_VIDEO_FORMATS = ["video/mp4"];
const SUPPORTED_FORMATS_IMAGE = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .min(3, "minimum length of a text is 3")
    .max(60, "maximum length of a text is 60")
    .matches(
      /^[A-Za-z]{2}[ A-Za-z0-9_-]*$/,
      "The Title must be alphanumeric characters only"
    )
    .required("Title is required"),
  type: Yup.string().required("Type is required"),
  category: Yup.string().required("Category is required"),
  status: Yup.string().required("Status is required"),
  track_selection: Yup.string().required("Track Selection is required"),
  isDemoSR: Yup.string().notRequired(),
  isPublic: Yup.string().required("SR Type is required, Select Public/Private"),
  files: Yup.mixed().nullable()
    .notRequired().test('fileType', "Unsupported File Format", value => value === null || (SUPPORTED_FORMATS_IMAGE.includes(value?.type))),
  bg_img: Yup.mixed().nullable()
    .notRequired().test('fileType', "Unsupported File Format", value => value === null || (SUPPORTED_FORMATS_IMAGE.includes(value?.type))),
  trailer: Yup.mixed().nullable()
    .notRequired().test("FILE_FORMAT", "Unsupported File Format.",
      value => !value || (value && SUPPORTED_VIDEO_FORMATS.includes(value.type))),
  bgmusic: Yup.mixed().nullable()
    .notRequired().test("FILE_FORMAT", "Unsupported File Format.",
      value => !value || (value && SUPPORTED_AUDIO_FORMATS.includes(value.type))),
  decisionTimerLimit: Yup.string().nullable().notRequired(),
  isFullScreenModeOn: Yup.string().notRequired(),
  is_scoring_optional: Yup.string().notRequired(),
  skip_menuitems_for_scene: Yup.string().notRequired(),
  continue_skip_configuration_for_scene: Yup.string().notRequired(),
  isAIChatbotEnabled: Yup.string().notRequired(),
});

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const SimulationForm = (props) => {
  const { category, sid } = useParams();
  const { scenarioApi, editScenarioApi, getThemesApi } = useRequests();
  const addScenario = useApi(scenarioApi);
  const getThemesList = useApi(getThemesApi);
  const editScenario = useApi(editScenarioApi);
  const {
    initialValues,
    edit,
    saveEditImg,
    scenarioDetails,
    setOpenEditForm,
    setOpenModal,
    setSnackBar,
    getScenariosList,
    onFileUpload,
    onImageUpload,
    onVideoUpload,
    onAudioUpload,
    fileUrl,
    file1Url,
    file2Url,
    file3Url,
    setFile2Url,
    setFile3Url,
    setFile1Url,
    setFileUrl,
    logoUrl,
    setLogoUrl,
    onLogoUploadFunc,
    handleAfterSubmit,
  } = props;
  const selectedItem = JSON.parse(localStorage.getItem("selectedCategory"));
  const navigate = useNavigate();
  const optionalImage = true;
  const {
    isPublished,
    setOpenApiSnackbar,
    setApiSnackbarMessage,
    setApiSnackbarSeverity,
    simulationStatus,
  } = useContext(GlobalState);

  const childFunc = React.useRef(null);
  const childFunc1 = React.useRef(null);
  const childFunc2 = React.useRef(null);
  const childFunc3 = React.useRef(null);
  const childFunc4 = React.useRef(null);

  const [clickedCustom, setClickedCustom] = useState(
    !edit ? false : scenarioDetails?.theme_name === "base" ? false : true
  );
  const [clickContinue, setClickContinue] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [saveImg, setSaveImg] = useState(saveEditImg ? saveEditImg : false);
  const [saveLogoImg, setSaveLogoImg] = useState(saveEditImg ? saveEditImg : false);
  const [saveBgImg, setSaveBgImg] = useState(saveEditImg ? saveEditImg : false);
  const [optionalImageSave, setOptionalImageSave] = useState(false);
  const [saveAudio, setSaveAudio] = useState(saveEditImg ? saveEditImg : false);
  const [saveVideo, setSaveVideo] = useState(saveEditImg ? saveEditImg : false);
  const [openModalAgian, setOpenModalAgian] = useState(false);
  const [nameTheme, setNameTheme] = React.useState("");
  const [tags, setTags] = React.useState("");
  const [btnDisable, setBtnDisable] = React.useState(false);

  const [handleUpdateImage, setHandleUpdateImage] = useState(
    saveEditImg ? saveEditImg : false
  );
  const [handleUpdateLogo, setHandleUpdateLogo] = useState(
    saveEditImg ? saveEditImg : false
  );
  const [handleUpdateBgImage, setHandleUpdateBgImage] = useState(
    saveEditImg ? saveEditImg : false
  );
  const [handleUpdateTrailer, setHandleUpdateTrailer] = useState(
    saveEditImg ? saveEditImg : false
  );
  const [handleUpdateBGMusic, setHandleUpdateBGMusic] = useState(
    saveEditImg ? saveEditImg : false
  );
  const [themeList, setThemeList] = useState([]);
  const [theme, setTheme] = React.useState(
    !edit ? "base" : scenarioDetails?.theme_name === "base" ? "base" : "custom"
  );
  const [themeValue, setThemeValue] = useState(
    edit ? scenarioDetails?.theme_name : "base"
  );

  const dental = [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ];
  const cyber = [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
  ];
  const medical = [];
  //   const [onDisable, setOnDisable] = useState(edit ? true : false)

  const saveImage = (value) => {
    setSaveImg(value);
  };

  const saveLogo = (value) => {
    setSaveLogoImg(value);
  };

  const saveBgImage = (value) => {
    setSaveBgImg(value);
  };

  const saveVideoFile = (value) => {
    setSaveVideo(value);
  };

  const optionalSaveImage = (value) => {
    setOptionalImageSave(value);
  };
  useEffect(() => {
    setOptionalImageSave(false);
    fetchThemesList();
    setFile3Url(scenarioDetails?.bg_music_url);
  }, []);
  const saveOnDisable = (value) => {
    // setOnDisable(value);
  };
  const handleEdit = (payload) => {
    editScenario
      .request(sid, payload)
      .then((res) => {
        if (res.status === 200) {
          setOpenEditForm(false);
          setSnackBar();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchThemesList = () => {
    getThemesList
      .request(1, 100)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.length > 0) {
            setThemeList([...res.data]);
          } else {
            setThemeList([]);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleUpdatedFile = (value) => {
    setHandleUpdateImage(value);
  };
  const handleUpdatedLogo = (value) => {
    setHandleUpdateLogo(value);
  };
  const handleUpdatedBgImage = (value) => {
    setHandleUpdateBgImage(value);
  };
  const handleUpdatedTrailer = (value) => {
    setHandleUpdateTrailer(value);
  };
  const handleUpdatedBGMusic = (value) => {
    setHandleUpdateBGMusic(value);
  };

  const radioHandler = (value, themevalue) => {
    setTheme(themevalue);
    setClickedCustom(value);
    if (value == false && themevalue == "base") {
      setThemeValue(themevalue);
    }
  };

  const handleOpenDrawer = (themeName) => {
    setNameTheme(themeName);
    setOpenModalAgian(true);
  };
  const handleCloseDrawerAgain = () => {
    setOpenModalAgian(false);
  };

  const handleSpinner = (value) => {
    setBtnDisable(value);
  }

  function handleSelecetedTags(items) {
    setTags(items);
  }

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  }

  return (
    <>
      <CssTabs value={selectedTab} onChange={handleTabChange} aria-label="basic tabs example">
        <CssTab label="Basic Info" id="basic-info" />
        <CssTab label="Scripts & Assets" id="scripts" />
      </CssTabs>
      <Formik
        initialValues={{ ...initialValues }}
        enableReinitialize
        validateOnMount={true}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          console.log('Searching values?.scriptsAsset',values?.scriptsAsset)
          setSubmitting(true);
          let payload = {
            title: values.title,
            banner: {
              url:
                fileUrl || values?.files || scenarioDetails?.banner_url || "",
            },
            logo: {
              url:
                logoUrl || values?.logo || "",
            },
            bg_img: {
              url:
                file1Url || values?.bg_img || scenarioDetails?.bg_img_url || "",
            },
            trailer: {
              url: file2Url || values.trailer || "",
            },
            bg_music: {
              url: values?.bgmusic || file3Url || "",
            },
            type: values.type,
            tags: tags,
            category_id: values.category,
            status: values.status,
            theme_name: values.theme_name,
            track_selection: values?.track_selection === "Yes" ? true : false,
            TestSR: values?.isTestSR === "Yes" ? true : false,
            isPublic: values?.isPublic === "Yes" ? true : false,
            playback: values?.playback === "Yes" ? true : false,
            randomizer: values?.randomizer === "Yes" ? true : false,
            isMenuInstructionEnable: values?.isMenuInstructionEnable === "Yes" ? true : false,
            decisionTimerLimit: values?.decisionTimerLimit === "null" ? null : values?.decisionTimerLimit,
            isFullScreenModeOn: values?.isFullScreenModeOn === "Yes" ? true : false,
            skeleton_bg_color: values?.skeleton_bg_color,
            skeleton_color: values?.skeleton_color,
            is_scoring_optional: values?.is_scoring_optional === "Yes" ? true : false,
            skip_menuitems_for_scene: values?.skip_menuitems_for_scene === "Yes" ? true : false,
            continue_skip_configuration_for_scene: values?.continue_skip_configuration_for_scene === "Yes" ? true : false,
            isAIChatbotEnabled: values?.isAIChatbotEnabled === "Yes" ? true : false,
            // SRType: values?.isTWILS === "Yes" ? "twils" : null,
            SRType: values?.isTWILS === "Yes" ? "twils" : (scenarioDetails?.SRType || "manual"),
            scriptsAsset: values?.scriptsAsset || [],
            font_size: values?.font_size || "16",
            font_family: values?.font_family || "Default",
          };

          setSubmitting(false);
          if (edit === true) {
            handleEdit(payload);
            setSubmitting(false);
          } else {
            addScenario
              .request(payload)
              .then((res) => {
                if (res.status === 200) {
                  if (clickContinue === "continue") {
                    localStorage.setItem(
                      "simulationItem",
                      JSON.stringify(res.data)
                    );
                    navigate(`/${category}/simulation/${res.data._id}`);
                  }
                  handleAfterSubmit();
                  setSubmitting(false);
                  setOpenModal(false);
                  setFileUrl("");
                  setFile1Url("");
                  setFile2Url("");
                  setFile3Url("");
                  setLogoUrl("");
                  getScenariosList(1, simulationStatus);
                  setSnackBar();
                  setClickContinue("save");
                  if (clickContinue === "save") {
                    setOpenApiSnackbar(true);
                    setApiSnackbarMessage("Data Saved Successfully");
                    setApiSnackbarSeverity("success");
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }}
      >
        {({
          dirty,
          values,
          errors,
          touched,
          handleSubmit,
          setFieldValue,
          resetForm,
          submitForm,
          isSubmitting,
          handleBlur,
        }) => (
          <>
          <CustomTabPanel value={selectedTab} index={0}>
            <Form onSubmit={handleSubmit}>
              {(typeof (values?.files) === 'string') ? delete errors.files : ''}
              {(typeof (values?.bg_img) === 'string') ? delete errors.bg_img : ''}
              {(typeof (values?.trailer) === 'string') ? delete errors.trailer : ''}
              {(typeof (values?.bgmusic) === 'string') ? delete errors.bgmusic : ''}
              <Container sx={{ marginTop: "20px" }}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FastField
                        component={CssTextField}
                        variant="outlined"
                        size="small"
                        name="title"
                        id="title"
                        label="Title*"
                        autoComplete="off"
                        value={values.title}
                        onBlur={(e) => handleBlur(e)}
                        // disabled={isPublished}
                        inputProps={{ readOnly: isPublished }}
                        onChange={(e) => {
                          setFieldValue("title", e.target.value);
                        }}
                        sx={{ marginTop: "0px" }}
                      />
                      {errors.title && touched.title ? (
                        <div className="errorText">{errors.title}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Type*
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="type"
                          variant="outlined"
                          size="small"
                          name="type"
                          label="Type*"
                          id="type"
                          onBlur={(e) => handleBlur(e)}
                          value={values.type}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("type", e.target.value);
                          }}
                        >
                          {typeOptions.map((item, i) => (
                            <MenuItem key={item.label} value={item.value}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors.type && touched.type ? (
                        <div className="errorText">{errors.type}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel
                          id="category"
                          className="select-label"
                        ></InputLabel>
                        <FastField
                          component={CssTextField}
                          variant="outlined"
                          size="small"
                          labelId="category"
                          id="category"
                          name="category"
                          label="Category"
                          value={selectedItem.name}
                          onBlur={(e) => handleBlur(e)}
                          inputProps={{ readOnly: true }}
                          onChange={(e) => {
                            setFieldValue("category", e.target.value);
                          }}
                          sx={{ marginTop: "0px" }}
                        ></FastField>
                      </FormControl>
                      {errors.category && touched.category ? (
                        <div className="errorText">{errors.category}</div>
                      ) : null}
                    </div>
                  </Grid>
                  {edit ? (
                    <Grid item xs={12}>
                      <div className="form_control">
                        <FormControl fullWidth size="small">
                          <InputLabel id="status" className="select-label">
                            Status*
                          </InputLabel>
                          <FastField
                            component={CssSelectField}
                            labelId="status"
                            variant="outlined"
                            name="status"
                            label="Status*"
                            id="status"
                            onBlur={(e) => handleBlur(e)}
                            value={values.status}
                            inputProps={{ readOnly: isPublished }}
                            onChange={(e) => {
                              setFieldValue("status", e.target.value);
                            }}
                          >
                            {statusOptions &&
                              statusOptions.map((item, i) => (
                                <MenuItem key={item.label} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ))}
                          </FastField>
                        </FormControl>
                        {errors.status && touched.status ? (
                          <div className="errorText">{errors.status}</div>
                        ) : null}
                      </div>
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <div className="form_control">
                        <FormControl fullWidth size="small">
                          <InputLabel
                            id="status"
                            className="select-label"
                          ></InputLabel>
                          <FastField
                            component={CssTextField}
                            labelId="status"
                            variant="outlined"
                            size="small"
                            name="status"
                            label="Status"
                            id="status"
                            onBlur={(e) => handleBlur(e)}
                            value={`Draft`}
                            inputProps={{ readOnly: true }}
                            onChange={(e) => {
                              setFieldValue("status", e.target.value);
                            }}
                            sx={{ marginTop: "0px" }}
                          ></FastField>
                        </FormControl>
                        {errors.status && touched.status ? (
                          <div className="errorText">{errors.status}</div>
                        ) : null}
                      </div>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <div className="form_control">
                      <TagsInput
                        selectedTags={handleSelecetedTags}
                        fullWidth
                        variant="outlined"
                        id="tags"
                        name="tags"
                        onBlur={(e) => handleBlur(e)}
                        tagsValue={values.tags}
                        setFieldValue={setFieldValue}
                        // placeholder="Add Tags"
                        label="Tags"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Track Selection*
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="track_selection"
                          variant="outlined"
                          size="small"
                          name="track_selection"
                          label="Track Selection*"
                          id="track_selection"
                          onBlur={(e) => handleBlur(e)}
                          value={values.track_selection}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("track_selection", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.track_selection && touched?.track_selection ? (
                        <div className="errorText">{errors?.track_selection}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Is Demo SR ?
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="isTestSR"
                          variant="outlined"
                          size="small"
                          name="isTestSR"
                          label="Is Demo SR ?"
                          id="isTestSR"
                          onBlur={(e) => handleBlur(e)}
                          value={values.isTestSR || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("isTestSR", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.isTestSR && touched?.isTestSR ? (
                        <div className="errorText">{errors?.isTestSR}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Public SR*
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="isPublic"
                          variant="outlined"
                          size="small"
                          name="isPublic"
                          label="SR Type*"
                          id="isPublic"
                          onBlur={(e) => handleBlur(e)}
                          value={values.isPublic}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("isPublic", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.isPublic && touched?.isPublic ? (
                        <div className="errorText">{errors?.isPublic}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Playback*
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="playback"
                          variant="outlined"
                          size="small"
                          name="playback"
                          label="Playback"
                          id="playback"
                          onBlur={(e) => handleBlur(e)}
                          value={values.playback}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("playback", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.playback && touched?.playback ? (
                        <div className="errorText">{errors?.playback}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Randomizer*
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="randomizer"
                          variant="outlined"
                          size="small"
                          name="randomizer"
                          label="randomizer "
                          id="randomizer"
                          onBlur={(e) => handleBlur(e)}
                          value={values.randomizer || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("randomizer", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.randomizer && touched?.randomizer ? (
                        <div className="errorText">{errors?.randomizer}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Enable Menu Instruction
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="isMenuInstructionEnable"
                          variant="outlined"
                          size="small"
                          name="isMenuInstructionEnable"
                          label="isMenuInstructionEnable"
                          id="isMenuInstructionEnable"
                          onBlur={(e) => handleBlur(e)}
                          value={values.isMenuInstructionEnable || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("isMenuInstructionEnable", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.isMenuInstructionEnable && touched?.isMenuInstructionEnable ? (
                        <div className="errorText">{errors?.isMenuInstructionEnable}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Is Full Screen Mode On
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="isFullScreenModeOn"
                          variant="outlined"
                          size="small"
                          name="isFullScreenModeOn"
                          label="Is Full Screen Mode On"
                          id="isFullScreenModeOn"
                          onBlur={(e) => handleBlur(e)}
                          value={values.isFullScreenModeOn || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("isFullScreenModeOn", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.isFullScreenModeOn && touched?.isFullScreenModeOn ? (
                        <div className="errorText">{errors?.isFullScreenModeOn}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                        Decision Timer Limit
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="decisionTimerLimit"
                          variant="outlined"
                          size="small"
                          name="decisionTimerLimit"
                          label="Decision Timer Limit"
                          id="decisionTimerLimit"
                          onBlur={(e) => handleBlur(e)}
                          value={values.decisionTimerLimit}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("decisionTimerLimit", e.target.value);
                          }}
                        >
                          {[{
                            item: "Select timer",
                            value: "null"
                          },
                          {
                            item: "30 sec",
                            value: "30"
                          }, {
                            item: "1 min",
                            value: "60"
                          }].map((item, i) => (
                            <MenuItem key={item.value} value={item.value}>
                              {item.item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.decisionTimerLimit && touched?.decisionTimerLimit ? (
                        <div className="errorText">{errors?.decisionTimerLimit}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Skip Scoring
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="is_scoring_optional"
                          variant="outlined"
                          size="small"
                          name="is_scoring_optional"
                          label="Skip Scoring"
                          id="is_scoring_optional"
                          onBlur={(e) => handleBlur(e)}
                          value={values.is_scoring_optional || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("is_scoring_optional", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.is_scoring_optional && touched?.is_scoring_optional ? (
                        <div className="errorText">{errors?.is_scoring_optional}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Skip Menu Items for Scene Nodes
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="skip_menuitems_for_scene"
                          variant="outlined"
                          size="small"
                          name="skip_menuitems_for_scene"
                          label="Skip Menu Items for Scene Nodes"
                          id="skip_menuitems_for_scene"
                          onBlur={(e) => handleBlur(e)}
                          value={values.skip_menuitems_for_scene || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("skip_menuitems_for_scene", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.skip_menuitems_for_scene && touched?.skip_menuitems_for_scene ? (
                        <div className="errorText">{errors?.skip_menuitems_for_scene}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Continue/Skip Configuration for Scene Nodes
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="continue_skip_configuration_for_scene"
                          variant="outlined"
                          size="small"
                          name="continue_skip_configuration_for_scene"
                          label="Continue/Skip Configuration for Scene Nodes"
                          id="continue_skip_configuration_for_scene"
                          onBlur={(e) => handleBlur(e)}
                          value={values.continue_skip_configuration_for_scene || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("continue_skip_configuration_for_scene", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.continue_skip_configuration_for_scene && touched?.continue_skip_configuration_for_scene ? (
                        <div className="errorText">{errors?.continue_skip_configuration_for_scene}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="type" className="select-label">
                          Show AI Chatbot
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="isAIChatbotEnabled"
                          variant="outlined"
                          size="small"
                          name="isAIChatbotEnabled"
                          label="Show AI Chatbot"
                          id="isAIChatbotEnabled"
                          onBlur={(e) => handleBlur(e)}
                          value={values.isAIChatbotEnabled || "No"}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("isAIChatbotEnabled", e.target.value);
                          }}
                        >
                          {["Yes", "No"].map((item, i) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors?.isAIChatbotEnabled && touched?.isAIChatbotEnabled ? (
                        <div className="errorText">{errors?.isAIChatbotEnabled}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="font-size" className="select-label">
                          Font Size
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="font-size"
                          variant="outlined"
                          size="small"
                          name="font_size"
                          label="Font Size"
                          id="font-size"
                          onBlur={(e) => handleBlur(e)}
                          value={values.font_size}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("font_size", e.target.value);
                          }}
                        >
                          {fontSizeOptions.map((item, i) => (
                            <MenuItem key={item.label} value={item.value}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors.type && touched.type ? (
                        <div className="errorText">{errors.type}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FormControl fullWidth size="small">
                        <InputLabel id="font-family" className="select-label">
                          Font Family
                        </InputLabel>
                        <FastField
                          component={CssSelectField}
                          labelId="type"
                          variant="outlined"
                          size="small"
                          name="font_family"
                          label="Font Family"
                          id="font_family"
                          onBlur={(e) => handleBlur(e)}
                          value={values.font_family}
                          inputProps={{ readOnly: isPublished }}
                          onChange={(e) => {
                            setFieldValue("font_family", e.target.value);
                          }}
                        >
                          {fontFamilyOptions.map((item, i) => (
                            <MenuItem key={item.label} value={item.value}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </FastField>
                      </FormControl>
                      {errors.type && touched.type ? (
                        <div className="errorText">{errors.type}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={5}>
                    <div className="form_control">
                      <FastField
                        component={CssTextField}
                        variant="outlined"
                        size="small"
                        name="skeleton_bg_color"
                        id="skeleton_bg_color"
                        value={values.skeleton_bg_color}
                        onBlur={handleBlur}
                        type="color"
                        onChange={(e) => {
                          setFieldValue("skeleton_bg_color", e.target.value);
                        }}
                        InputProps={{
                          className: "text-field",
                        }}
                        label="Primary Color"
                        helperText="Select color for the skeleton background"
                      />
                      {errors.skeleton_bg_color && touched.skeleton_bg_color ? (
                        <div className="errorText">{errors.skeleton_bg_color}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={5}>
                    <div className="form_control">
                      <FastField
                        component={CssTextField}
                        variant="outlined"
                        size="small"
                        name="skeleton_color"
                        id="skeleton_color"
                        value={values.skeleton_color}
                        onBlur={handleBlur}
                        type="color"
                        onChange={(e) => {
                          setFieldValue("skeleton_color", e.target.value);
                        }}
                        InputProps={{
                          className: "text-field",
                        }}
                        label="Primary Color"
                        helperText="Select color for the skeleton"
                      />
                      {errors.skeleton_color && touched.skeleton_color ? (
                        <div className="errorText">{errors.skeleton_color}</div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form_control">
                      <FileUpload
                        name="files"
                        id="files"
                        multiple={false}
                        selectedFile={
                          handleUpdateImage
                            ? scenarioDetails?.banner_url
                            : values?.files
                        }
                        onFileUpload={onFileUpload}
                        saveImage={saveImage}
                        handleUpdatedFile={handleUpdatedFile}
                        simulationForm={true}
                        optionalImage={!optionalImage}
                        accept={{ "image/*": [".jpeg", ".png", ".jpg"] }}
                        saveOnDisable={saveOnDisable}
                        childFunc={childFunc1}
                        bucket={"scenario-banners"}
                        title="Poster*"
                        handleSpinner={handleSpinner}
                      />
                      {errors.files && errors.files ? (
                        <div className="errorText" style={{ top: 0, position: 'relative' }}>
                          {errors.files}
                        </div>
                      ) : null}
                    </div>
                    <div className="form_control" style={{ paddingTop: "25px" }}>
                      <FileUpload
                        name="logo"
                        id="logo"
                        multiple={false}
                        selectedFile={
                          handleUpdateLogo
                            ? scenarioDetails?.logo?.url
                            : values?.logo
                        }
                        onFileUpload={onLogoUploadFunc}
                        saveImage={saveLogo}
                        handleUpdatedFile={handleUpdatedLogo}
                        simulationForm={true}
                        optionalImage={!optionalImage}
                        accept={{ "image/*": [".jpeg", ".png", ".jpg"] }}
                        saveOnDisable={saveOnDisable}
                        childFunc={childFunc4}
                        bucket={"scenario-banners"}
                        title="Logo"
                        handleSpinner={handleSpinner}
                      />
                      {errors.logo && errors.logo ? (
                        <div className="errorText" style={{ top: 0, position: 'relative' }}>
                          {errors.logo}
                        </div>
                      ) : null}
                    </div>
                    <div className="form_control" style={{ paddingTop: "25px" }}>
                      <FileUpload
                        name="bg_img"
                        id="bg_img"
                        multiple={false}
                        selectedFile={
                          handleUpdateBgImage
                            ? scenarioDetails?.bg_img_url?.url || scenarioDetails?.bg_img_url || scenarioDetails?.bg_img?.url || scenarioDetails?.bg_img?.url?.url
                            : values?.bg_img
                        }
                        onFileUpload={onImageUpload}
                        saveImage={saveBgImage}
                        handleUpdatedFile={handleUpdatedBgImage}
                        simulationForm={true}
                        optionalImage={!optionalImage}
                        accept={{ "image/*": [".jpeg", ".png", ".jpg"] }}
                        saveOnDisable={saveOnDisable}
                        childFunc={childFunc3}
                        bucket={"scenario-banners"}
                        title="Background Image"
                        handleSpinner={handleSpinner}
                      />
                      {errors.bg_img && errors.bg_img ? (
                        <div className="errorText" style={{ top: 0, position: 'relative' }}>
                          {errors.bg_img}
                        </div>
                      ) : null}
                    </div>
                    <div className="form_control" style={{ paddingTop: "25px" }}>
                      <FileUpload
                        name="trailer"
                        id="trailer"
                        multiple={false}
                        selectedFile={
                          handleUpdateTrailer
                            ? scenarioDetails?.trailer?.url
                            : values?.trailer
                        }
                        onFileUpload={onVideoUpload}
                        handleUpdatedFile={handleUpdatedTrailer}
                        saveImage={saveVideoFile}
                        optionalImage={!optionalImage}
                        simulationForm={true}
                        accept={{ "video/*": [".mp4"] }}
                        saveOnDisable={saveOnDisable}
                        childFunc={childFunc}
                        isPublished={isPublished}
                        bucket={"axontrailers"}
                        title="Open Credit Video"
                        handleSpinner={handleSpinner}
                      />
                      {errors.trailer && errors.trailer ? (
                        <div className="errorText" style={{ top: 0, position: 'relative' }}>
                          {errors.trailer}
                        </div>
                      ) : null}
                    </div>

                    <div className="form_control" style={{ paddingTop: "25px" }}>
                      <FileUpload
                        name="bgmusic"
                        id="bgmusic"
                        multiple={false}
                        selectedFile={
                          handleUpdateBGMusic
                            ? scenarioDetails?.bg_music?.url
                            : values?.bgmusic
                        }
                        onFileUpload={onAudioUpload}
                        saveImage={saveImage}
                        simulationForm={true}
                        optionalSaveImage={optionalSaveImage}
                        optionalImage={optionalImage}
                        handleUpdatedFile={handleUpdatedBGMusic}
                        accept={{ "audio/*": [".mp3", ".ogg"] }}
                        isPublished={isPublished}
                        saveOnDisable={saveOnDisable}
                        childFunc={childFunc2}
                        bucket={"bg-music"}
                        title="Background Music"
                        handleSpinner={handleSpinner}
                      />
                      {errors.bgmusic && errors.bgmusic ? (
                        <div className="errorText" style={{ top: 0, position: 'relative' }}>
                          {errors.bgmusic}
                        </div>
                      ) : null}
                    </div>

                    <Grid item xs={12} sx={{ marginTop: "40px" }}>
                      <div className="form_control">
                        <FormControl fullWidth size="small">
                          <InputLabel id="type" className="select-label">
                            TWILS (Mobile Friendly)
                          </InputLabel>
                          <FastField
                            component={CssSelectField}
                            labelId="isTWILS"
                            variant="outlined"
                            size="small"
                            name="isTWILS"
                            label="TWILS (Mobile Friendly)"
                            id="isTWILS"
                            onBlur={(e) => handleBlur(e)}
                            value={values.isTWILS || "No"}
                            inputProps={{ readOnly: isPublished }}
                            disabled={edit}
                            onChange={(e) => {
                              setFieldValue("isTWILS", e.target.value);
                            }}
                          >
                            {["Yes", "No"].map((item, i) => (
                              <MenuItem key={item} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </FastField>
                        </FormControl>
                        {errors?.isTWILS && touched?.isTWILS ? (
                          <div className="errorText">{errors?.isTWILS}</div>
                        ) : null}
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <div className="form_control">
                        {values?.isTWILS !== "Yes" && <FormControl style={{ marginTop: "12px" }}>
                          <RadioGroup
                            row
                            name="theme-buttons-group"
                            onChange={(e) => {
                              if (!isPublished) {
                                if (e.target.value === "base") {
                                  setFieldValue("theme_name", e.target.value);
                                  radioHandler(false, e.target.value);
                                }
                                if (e.target.value === "custom") {
                                  radioHandler(true, e.target.value);
                                  setThemeValue("");
                                }
                              }
                            }}
                          >
                            <FormControlLabel
                              value="base"
                              control={<Radio />}
                              checked={theme === "base"}
                              label="Base Theme"
                            />
                            <FormControlLabel
                              value="custom"
                              control={<Radio />}
                              checked={theme === "custom"}
                              label="Custom Theme"
                            />
                          </RadioGroup>
                        </FormControl>}
                        {clickedCustom && themeList && themeList.length > 0 && (
                          <div style={{ display: "flex" }}>
                            <FormControl
                              style={{ width: "180px", marginTop: "10px" }}
                              size="small"
                            >
                              <InputLabel id="type" className="select-label">
                                Theme*
                              </InputLabel>
                              <FastField
                                component={CssSelectField}
                                labelId="theme_name"
                                variant="outlined"
                                size="small"
                                name="theme_name"
                                label="Theme*"
                                id="theme_name"
                                onBlur={handleBlur}
                                value={themeValue || values.theme_name}
                                // defaultValue="dental"
                                inputProps={{ readOnly: isPublished }}
                                onChange={(e) => {
                                  if (!isPublished) {
                                    setFieldValue("theme_name", e.target.value);
                                    setThemeValue(e.target.value);
                                  }
                                }}
                              >
                                {themeList[0].docs?.map((item, i) => (
                                  <MenuItem
                                    selected={i === 1}
                                    key={item.name}
                                    value={item.name}
                                  >
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </FastField>
                            </FormControl>
                            <Grid item xs={6} ml={3} mt={1}>
                              <Stack
                                spacing={2}
                                direction="row"
                                justifyContent={"flex-start"}
                              >
                                <Button
                                  variant="contained"
                                  sx={{ width: "max-content !important" }}
                                  onClick={() =>
                                    handleOpenDrawer(values.theme_name)
                                  }
                                >
                                  Preview
                                </Button>
                              </Stack>
                            </Grid>
                          </div>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack
                      spacing={2}
                      direction="row"
                      justifyContent={"flex-start"}
                    >
                      {edit ? null : (
                        <CssButton
                          variant="contained"
                          sx={{ width: "max-content !important" }}
                          onClick={() => {
                            setClickContinue("continue");
                            submitForm();
                          }}
                          disabled={
                            isSubmitting ||
                            !saveImg ||
                            optionalImageSave ||
                            !themeValue
                          }
                        >
                          {isSubmitting ? <CssCircularProgress size={20} /> : "Continue"}
                        </CssButton>
                      )}

                      {edit ? (
                        <CssButton
                          variant="contained"
                          sx={{ width: "max-content !important" }}
                          onClick={() => {
                            submitForm();
                          }}
                          disabled={
                            isSubmitting ||
                            isPublished ||
                            !dirty ||
                            !saveImg ||
                            optionalImageSave ||
                            !themeValue ||
                            btnDisable
                          }
                        >
                          {isSubmitting ? <CssCircularProgress size={20} /> : "Update"}
                        </CssButton>
                      ) : (
                        <CssButton
                          variant="contained"
                          sx={{ width: "max-content !important" }}
                          onClick={() => {
                            setClickContinue("save");
                            submitForm();
                          }}
                          disabled={
                            isSubmitting ||
                            isPublished ||
                            !saveImg ||
                            optionalImageSave ||
                            !themeValue ||
                            btnDisable
                          }
                        >
                          {isSubmitting ? <CssCircularProgress size={20} /> : "Save"}
                        </CssButton>
                      )}
                      {edit ? null : (
                        <CssButton
                          variant="contained"
                          type="reset"
                          sx={{
                            width: "max-content !important",
                            backgroundColor: "#673068",
                          }}
                          onClick={() => {
                            childFunc.current();
                            childFunc1.current();
                            childFunc2.current();
                            childFunc3.current();
                            childFunc4.current();
                            resetForm();
                            setTheme("base");
                            setClickedCustom(false);
                          }}
                          disabled={!dirty}
                        >
                          Reset
                        </CssButton>
                      )}
                    </Stack>
                  </Grid>
                </Grid>
              </Container>
              <ModalContainer
                open={openModalAgian}
                handleClose={handleCloseDrawerAgain}
                title={`${nameTheme} preview `}
              >
                {nameTheme === "dental" &&
                  dental.map((item, i) => (
                    <img
                      style={{
                        width: "100%",
                        height: "45%",
                        borderRadius: "4px",
                        marginTop: "4px",
                        border: "2px solid",
                      }}
                      src={`https://axonteststorage.blob.core.windows.net/themes/theme-preview/${nameTheme}/${nameTheme}/${item}.png`}
                      alt={`${item}.png`}
                    />
                  ))}
                {nameTheme === "cyber" &&
                  cyber.map((item, i) => (
                    <img
                      style={{
                        width: "100%",
                        height: "45%",
                        borderRadius: "4px",
                        marginTop: "4px",
                        border: "2px solid",
                      }}
                      src={`https://axonteststorage.blob.core.windows.net/themes/theme-preview/${nameTheme}/${nameTheme}/${item}.png`}
                      alt={`${item}.png`}
                    />
                  ))}
                {nameTheme === "medical" && (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    <h4
                      style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        lineHeight: "500px",
                      }}
                    >
                      No Preview
                    </h4>
                  </div>
                )}
              </ModalContainer>
            </Form>
          </CustomTabPanel>
          <CustomTabPanel value={selectedTab} index={1}>
            <AssetsForm />
          </CustomTabPanel>
          </>
        )}
      </Formik>
    </>
  );
};
export default SimulationForm;
